import { Injectable } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Marcar, Usuario } from '../app.models';
import { ToastController, AlertController } from '@ionic/angular';
import { appconfig } from '../app.configFirebase';
import * as firebase from 'Firebase';


@Injectable({
	providedIn: 'root',
})
export class ServFirebaseService {

	marcar: AngularFirestoreCollection<Marcar>;
	usuarioConectado: any;
	ingreso = 0
	BaseDeDatos: any
	idEmpresa = null;

	constructor(public toastCtrl: ToastController, private db: AngularFirestore, public alertCtrl: AlertController,
		public afAuth: AngularFireAuth) {
		this.marcar = db.collection<Marcar>(appconfig.marcar_endpoint);
		this.BaseDeDatos = firebase.firestore();
		this.registrarService();
	}


	registrarService() {
		try {
			//console.log("Entro en registrarservice()")
			if ('serviceWorker' in navigator) {
				navigator.serviceWorker.register('service-worker.js').then(function (swReg) {
					//console.log("Voy a registrar el service")
					let newWorker;
					if (swReg.active) {
						navigator.serviceWorker.register('service-worker.js').then(reg => {
							//	console.log("Se registro el service")
							reg.addEventListener('updatefound', () => {
								// console.log("updatefound")
								// An updated service worker has appeared in reg.installing!
								newWorker = reg.installing;

								newWorker.addEventListener('statechange', () => {
									//console.log("statechange")
									// Has service worker state changed?
									switch (newWorker.state) {
										case 'installed':

											// There is a new service worker available, show the notification
											if (navigator.serviceWorker.controller) {
												// console.log("skipWaiting")
												/*const title = "Aviso";
												const options = {
													body: "Se encontro una nueva actualización!! se va a reiniciar la aplicación, aguarde unos segundos",
													icon: 'images/icon.png',
													sound: "cool_sound",
													//badge: 'images/badge.png'
												};
												var n = new Notification(title, options);
												setTimeout(n.close.bind(n), 4000);
												n.onclick = function (event) {
													n.close()
												}*/
												//alert("Se encontro una nueva actualización!! se va a reiniciar la aplicación, aguarde unos segundos")
												//newWorker.postMessage({ action: 'skipWaiting' });
												const options = {
													body: "Se encontro una nueva actualización!! se va a reiniciar la aplicación, aguarde unos segundos",
													icon: 'images/icon.png',
													sound: "cool_sound",
													//badge: 'images/badge.png'
												};
												reg.showNotification("Aviso", options);
											}
											break;
									}
								});
							});
						});
						let refreshing;
						navigator.serviceWorker.addEventListener('controllerchange', function () {
							//console.log("controllerchange")
							if (refreshing) return;
							window.location.reload();
							refreshing = true;
						});
					} else {

					}
				}).catch(function (error) {
					console.error('Service Worker Error', error);
				});
			} else {

			}
		} catch (error) {
			console.log(error)
		}

	}



	cargarVariable(usuario) {
		let db = this.db.collection<Usuario>(usuario);
		return db;
	}

	signInWithEmail(credentials) {
		return this.afAuth.auth.signInWithEmailAndPassword(credentials.email,
			credentials.password);
	}

	// inicar seccion con un ususario anonimo
	loginAsGuest() {
		return firebase.auth().signInAnonymously();
	}
	// Cerrar seccion
	logout() {
		return firebase.auth().signOut();
	}

	// iniciar seccion con una cuenta de google
	signInWithGoogle() {
		return new Promise((resolve, reject) => {
			try {
				return this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(result => {
					resolve(result);
				}).catch(function (error) {
					console.log(error)
					if (this.ingreso == 0) {
						this.ingreso = 1
						this.signInWithGoogle().then((res: any) => {
							resolve(res)
						});
					} else {
						resolve("Error");
					}
				});
			} catch (error) {
				resolve("Error");
			}
		})

	}


	signInWithGoogle2() {
		return new Promise((resolve, reject) => {
			this.oauthSignIn(new firebase.auth.GoogleAuthProvider()).then(result => {
				try {
					resolve(result);
				} catch (error) {
					console.log(error)
				}

			});
		}
		)
	}
	oauthSignIn(provider) {
		return new Promise((resolve, reject) => {
			if (!(<any>window).cordova) {
				this.afAuth.auth.signInWithPopup(provider).then(result => {
					try {
						resolve(result);
					} catch (error) {
						console.log(error)
					}
				}).catch(function (error) {
					reject("Error");
				});
			} else {
				this.afAuth.auth.signInWithRedirect(provider)
					.then(() => {
						this.afAuth.auth.getRedirectResult().then(result => {
							let user = result.user;
							try {
								resolve(user);
							} catch (error) {
								console.log(error)
							}
							console.log(user);
						}).catch(function (error) {
							reject("Error");
						});
					});
			}
		});
	}

	signInWithTwitter() {
		try {
			console.log('Sign in with twitter');
			//return this.oauthSignIn(new firebase.auth.GoogleAuthProvider());
			return this.afAuth.auth.signInWithPopup(new firebase.auth.TwitterAuthProvider()).then(result => {
				//	var token = result.credential;
				var user = result.user;
				//console.log(token)
				console.log(user)
				return result;
			}).catch(function (error) {
				console.log(error)
				return "Error";
			});
		} catch (error) {
			console.log(error)
		}

	}

	loginWithFacebook() {
		try {
			console.log('Sign in with facebook');
			return this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider()).then(result => {
				//var token = result.credential;
				var user = result.user;
				//console.log(token)
				console.log(user)
				return result;
			}).catch(function (error) {
				console.log(error)
				return "Error";
			});
		} catch (error) {
			console.log(error)
		}
	}

	// Devuelve la session
	get_Session() {
		return this.afAuth.authState;
	}


	obtenerListado(usuario) {
		try {
			console.log(usuario)
			return new Promise((resolve, reject) => {
				this.db.collection<Marcar>(appconfig.marcar_endpoint, ref => {
					return ref.where("usuario", "==", usuario);
				}).valueChanges().subscribe(users => {
					//resolve(users.length);
					console.log(users)
				});
			}).catch(err => {
			})
		} catch (error) {
			console.log(error)
		}
	}


	updateSalida(hora, id, usuario) {
		return new Promise((resolve, reject) => {
			this.db.collection<Usuario>(usuario).doc(id).update({
				Salida: hora
			}).then(res => {
				resolve("Ok");
			})
				.catch(err => {
					resolve("error:" + err);
				});
		});
	}

	confirmarsiYaMarco2(accion, usuario, fecha) {
		try {
			return new Promise((resolve, reject) => {
				let sub = this.db.collection<Usuario>(usuario, ref => {
					return ref.where("usuario", "==", usuario).where("fecha", "==", fecha);
				}).valueChanges().subscribe(users => {
					if (accion == "Ingreso") {
						sub.unsubscribe()
						resolve(users.length);
					} else if (accion == "Salida") {
						sub.unsubscribe()
						resolve(users);
					} else {
						sub.unsubscribe()
						resolve(users)
					}
				});
			}).catch(err => {

			})
		} catch (error) {
			console.log(error)
		}
	}

	verificarUltimoIngreso(usuario) {
		try {
			return new Promise((resolve, reject) => {
				let subs = this.db.collection<Usuario>(usuario, ref => {
					return ref.where("usuario", "==", usuario).orderBy("fecha", "desc");
				}).valueChanges().subscribe(users => {
					if (users.length > 0) {
						console.log(users)
						if (users[0].Salida == "") {
							//this.MarcarSalida(users[0].usuario, users[0].fecha, "18:00")
							subs.unsubscribe();
							resolve("Ok");
						} else {
							subs.unsubscribe();
							resolve("Ok");
						}
					} else {
						subs.unsubscribe();
						resolve("Ok");
					}
				});
			}).catch(err => {
				console.log(err)
			})
		} catch (error) {
			console.log(error)
		}

	}

	verificarUltimoIngreso2(usuario) {
		try {
			return new Promise((resolve, reject) => {
				this.db.collection<Usuario>(usuario).valueChanges().subscribe(datos => {
					if (datos.length > 0) {
						console.log(datos)

					} else {
						console.log(datos)
					}
				});
			}).catch(err => {
				console.log(err)
			})
		} catch (error) {
			console.log(error)
		}

	}



	obtenerUsuarios() {
		return new Promise((resolve, reject) => {
			let usuario = [];
			this.db.collection(appconfig.infoUsu_endpoint).snapshotChanges().subscribe((usu: any) => {
				usuario.length = 0;
				usu.map(a => {
					const data = a.payload.doc.data();
					const id = a.payload.doc.id;
					//console.log(data)
					usuario.push({
						id: id,
						name: data.name,
						correo: data.correo,
						isAdmin: data.isAdmin,
						google: data.google,
						facebook: data.facebook,
						password: data.password
					})

				})
				//this.getRubros("ok");
				//	console.log(usuario)
				if (usuario.length > 0) {
					resolve(usuario)
				} else {
					resolve("Error")
				}
				//resolve(productos);
			}
			)
		})
	}
	//idEmpresa
	obtenerUsuariosDeEmpresa(id) {
		return new Promise((resolve, reject) => {
			let usuario = [];
			this.db.collection(appconfig.infoUsu_endpoint, ref => {
				return ref.where("idEmpresa", "==", id)
			}).snapshotChanges().subscribe((usu: any) => {
				usuario.length = 0;
				usu.map(a => {
					const data = a.payload.doc.data();
					const id = a.payload.doc.id;
					//console.log(data)
					usuario.push({
						id: id,
						name: data.name,
						correo: data.correo,
						isAdmin: data.isAdmin,
						google: data.google,
						facebook: data.facebook,
						password: data.password
					})

				})
				//this.getRubros("ok");
				//	console.log(usuario)
				if (usuario.length > 0) {
					resolve(usuario)
				} else {
					resolve("Error")
				}
				//resolve(productos);
			}
			)
		})
	}

	obtenerDatosUsuario(id) {
		try {
			return new Promise((resolve, reject) => {
				try {
					this.db.collection(appconfig.infoUsu_endpoint).doc(id).valueChanges().subscribe(res => {
						this.usuarioConectado = res
						resolve(res)
					});
				} catch (error) {
					resolve("Error")
				}

			});
		} catch (error) {
			console.log(error)
		}

	}





	//------------------------------- Version 3 --------------------------------

	//Funcion que verifica si se marco el ingreso, si no hay registro, realiza el primero, si ya lo hay para la misma fecha 
	//notifica que ya marco

	confirmarSiMarcoID(id, accion, hora, usuario, a) {
		//console.log("Confirarsimarco - " + id + "  - " + accion + "  -   " + hora)
		try {
			return new Promise((resolve, reject) => {
				let docarray = []
				this.BaseDeDatos.collection("Marcar").doc(id).collection("Log").orderBy("Date", "desc")
					.limit(1)
					.get().then((querySnapshot: any) => {
						querySnapshot.forEach(function (doc) {
							docarray.push({
								id: doc.id,
								datos: doc.data(),
							})
						});
						//console.log(docarray)
						if (docarray.length == 0) {
							if (accion == "Ingreso") {
								this.MarcarIngreso(id, hora, usuario).then((res: any) => {
									resolve(res)
								});
							} else if (accion == "Salida") {
								resolve("ErrorSalida")
							}
						} else if (docarray.length != 0) {
							docarray.sort(function (o1, o2) {
								if (o1.datos.Date < o2.datos.Date) { //comparación lexicogŕafica
									return 1;
								} else if (o1.datos.Date > o2.datos.Date) {
									return -1;
								}
								return 0;
							});
							let diadehoy = this.obtenerFechayHora();
							if (docarray[0].datos.Fecha == diadehoy.fecha) {
								if (accion == "Ingreso") {
									resolve("YaMarco");
								} else if (accion == "Salida") {
									this.MarcarSalida(id, docarray[0].id, diadehoy.hora).then((res: any) => {
										resolve(res)
									})
								}
							} else {
								if (accion == "Ingreso") {
									if (docarray[0].datos.Salida == "") {
										this.MarcarSalida(id, docarray[0].id, "18:00:00")
										this.MarcarIngreso(id, hora, usuario).then((res: any) => {
											resolve(res)
										});
									} else {
										this.MarcarIngreso(id, hora, usuario).then((res: any) => {
											resolve(res)
										});
									}
								} else if (accion == "Salida") {
									resolve("ErrorSalida")
								}
							}
						}
					}).catch(error => {
						console.log(error)
					})

			})
		} catch (error) {
			console.log(error)
		}
	}


	MarcarIngreso(id, hora, usuario) {
		return new Promise((resolve, reject) => {
			let Date = this.obtenerFechayHora()
			let db = this.db.collection("Marcar").doc(id).collection("Log");
			db.add({
				Date: Date.date,
				Fecha: Date.fecha,
				Ingreso: hora,
				Salida: "",
				usuario: usuario
			}).then(res => {
				resolve("Ok");
			}).catch(err => {
				resolve("error:" + err);
			});

		}).catch(err => {
			console.log(err)
		})
	}

	MarcarSalida(usuario, id, hora) {
		try {
			return new Promise((resolve, reject) => {
				try {
					this.BaseDeDatos.collection("Marcar").doc(usuario).collection("Log").doc(id).update({
						Salida: hora
					}).then(res => {
						resolve("Ok");
					})
				} catch (error) {
					console.log(error)
				}

			}).catch(err => {
				console.log(err)
			});

		} catch (error) {
			console.log(error)
		}
	}


	getReporte(usuario) {
		try {
			return new Promise((resolve, reject) => {
				try {
					this.BaseDeDatos.collection("Marcar").doc(usuario).collection("Log").orderBy("Date", "desc")
						.limit(50)
						.get().then((querySnapshot: any) => {
							let docarray = []
							querySnapshot.forEach(function (doc) {
								docarray.push({
									id: doc.id,
									Fecha: doc.data().Fecha,
									Ingreso: doc.data().Ingreso,
									Salida: doc.data().Salida
								})
							})
							if (docarray.length == 0) {
								resolve("Error")
							} else {
								resolve(docarray)
							}
						})
				} catch (error) {
					console.log(error)
				}

			})
		} catch (error) {
			console.log(error)
		}
	}



	obtenerFechayHora() {
		var d = new Date();
		let mesmod = d.getMonth() + 1
		let mesmod2
		if (mesmod < 10) {
			mesmod2 = "0" + mesmod.toString()
		} else {
			mesmod2 = mesmod.toString();
		}
		let diamod: any
		diamod = d.getDate()
		if (diamod < 10) {
			diamod = "0" + diamod.toString()
		}
		let fecha = diamod + "/" + mesmod2 + "/" + d.getFullYear();
		let h2: any
		h2 = d.getHours()
		let mi: any
		mi = d.getMinutes()
		let s: any
		s = d.getSeconds()
		if (h2 < 10) {
			h2 = "0" + h2.toString()
		}
		if (mi < 10) {
			mi = "0" + mi.toString()
		}
		if (s < 10) {
			s = "0" + s.toString()
		}
		let hora = h2 + ":" + mi + ":" + s;

		let dia = {
			date: d,
			fecha: fecha,
			hora: hora,
			mes: mesmod2
		};
		return dia;
	}






	CrearUsuario(name, password, correo, idEmpresa, NameEmpresa, redSocial, isAdmin) {
		return new Promise((resolve, reject) => {
			try {
				if (redSocial == false) {
					this.crearCorreo(correo, password).then(res => {
						if (res != "Error") {
							let db = this.db.collection("InfoUsuarios");
							db.add({
								name: name,
								isAdmin: isAdmin,
								correo: correo,
								idEmpresa: idEmpresa,
								nameEmpresa: NameEmpresa,
								password: password,
								redSocial: redSocial
							}).then(res => {
								//console.log(res)
								resolve(res.id);
							}).catch(err => {
								resolve("Error");
							});
						} else {
							resolve("Error")
						}
					})
				} else {
					let db = this.db.collection("InfoUsuarios");
					db.add({
						name: name,
						isAdmin: isAdmin,
						correo: correo,
						idEmpresa: idEmpresa,
						nameEmpresa: NameEmpresa,
						password: password,
						redSocial: redSocial

					}).then(res => {
						//console.log(res)
						resolve(res.id);
					}).catch(err => {
						resolve("Error");
					});
				}
			} catch (error) {

			}


		}).catch(err => {
			console.log(err)
		})
	}

	CrearEmpresa(name, horas, token, latitud, longitud) {
		return new Promise((resolve, reject) => {
			let db = this.db.collection("Empresas");
			db.add({
				name: name,
				horas: horas,
				token: token,
				latitud: latitud,
				longitud: longitud
			}).then(res => {
				//console.log(res)
				resolve(res.id);
			}).catch(err => {
				resolve("Error");
			});

		}).catch(err => {
			console.log(err)
		})
	}

	tokenEmpresa(token) {
		try {
			return new Promise((resolve, reject) => {
				let subs = this.db.collection("Empresas", ref => {
					return ref.where("token", "==", token)
				}).snapshotChanges().subscribe((empresas: any) => {
					if (empresas.length != 0) {
						let encontrada = []
						empresas.map(a => {
							const data = a.payload.doc.data();
							const id = a.payload.doc.id;
							//console.log(data)
							encontrada.push({
								id: id,
								name: data.name,
								correo: data.token
							})
						})
						resolve(encontrada)
						subs.unsubscribe()
					} else if (empresas.length == 0) {
						resolve("Error")
						subs.unsubscribe()
					} else {
						resolve("Error")
						subs.unsubscribe()
					}
				});
			}).catch(err => {
				console.log(err)
			})
		} catch (error) {
			console.log(error)
		}
	}


	modificarUsuario(id, campo, newdato) {
		return new Promise((resolve, reject) => {
			try {
				if (campo == "correo") {
					this.db.collection("InfoUsuarios").doc(id).update({
						correo: newdato
					}).then(res => {
						resolve("Ok");
					})
				} else if (campo == "google") {
					this.db.collection("InfoUsuarios").doc(id).update({
						google: newdato
					}).then(res => {
						resolve("Ok");
					})
				} else if (campo == "facebook") {
					this.db.collection("InfoUsuarios").doc(id).update({
						facebook: newdato
					}).then(res => {
						resolve("Ok");
					})
				}

			} catch (error) {
				console.log(error)
			}

		}).catch(err => {
			console.log(err)
		})

	}


	obtenerListaDeCorreos() {
		return new Promise((resolve, reject) => {
			this.db.collection("Correos").valueChanges().subscribe(res => {
				resolve(res)
			});
		});
	}



	crearCorreo(correo, password) {
		return new Promise((resolve, reject) => {
			try {
				this.existeCorreo(correo).then(res => {
					if (res == "Existe") {
						this.presentToast("El correo ya existe, utilice otro o contacte con el administrador de tu empresa", 8000)
						resolve("Error")
					} else if (res == "NoExiste") {
						let res = firebase.auth().createUserWithEmailAndPassword(correo, password);
						resolve(res)
					}
				})
			} catch (error) {
				console.log(error)
			}
		});

	}

	crearCorreoBaseDeDatos(correo, password) {
		return new Promise((resolve, reject) => {
			let db = this.db.collection("Correos");
			db.add({
				correo: correo,
				password: password

			}).then(res => {
				//console.log(res)
				resolve(res.id);
			}).catch(err => {
				resolve("Error");
			});

		}).catch(err => {
			console.log(err)
		})
	}

	existeCorreo(correo) {
		try {
			return new Promise((resolve, reject) => {
				let subs = this.db.collection("InfoUsuarios", ref => {
					return ref.where("correo", "==", correo)
				}).valueChanges().subscribe(users => {
					if (users.length > 0) {
						//console.log(users)
						subs.unsubscribe();
						resolve("Existe");
					} else {
						subs.unsubscribe();
						resolve("NoExiste");
					}
				});
			}).catch(err => {
				console.log(err)
			})
		} catch (error) {
			console.log(error)
		}

	}

	obtenerDatosPorCorreo(correo) {
		try {
			return new Promise((resolve, reject) => {
				let subs = this.db.collection("InfoUsuarios", ref => {
					return ref.where("correo", "==", correo)
				}).snapshotChanges().subscribe((usu: any) => {
					if (usu.length != 0) {
						let encontrada = []
						usu.map(a => {
							const data = a.payload.doc.data();
							const id = a.payload.doc.id;
							encontrada.push({
								id: id,
								name: data.name,
								password: data.password
							})
						})
						//console.log(encontrada)
						resolve(encontrada)
						subs.unsubscribe()
					} else if (usu.length == 0) {
						resolve("Error")
						subs.unsubscribe()
					} else {
						resolve("Error")
						subs.unsubscribe()
					}
				});
			}).catch(err => {
				console.log(err)
			})
		} catch (error) {
			console.log(error)
		}
	}

	obtenerDatosEmpresa(id) {
		try {
			return new Promise((resolve, reject) => {
				try {
					let sub = this.db.collection("Empresas").doc(id).valueChanges().subscribe(res => {
						sub.unsubscribe();
						resolve(res)
					});
				} catch (error) {
					resolve("Error")
					console.log(error)
				}
			})
		} catch (error) {
			console.log(error)
		}
	}

	presentToast(msg, time) {
		const toast = this.toastCtrl.create({
			message: msg,
			duration: time,
			position: 'top'
		});
		toast.then(alert => alert.present());
	}


	restarHoras(horaIngreso, horaFin, limite) {
		let inicio = horaIngreso;
		let fin = horaFin;
		let horasLimites = parseInt(limite);

		let inicioMinutos = parseInt(inicio.substr(3, 2));
		let inicioHoras = parseInt(inicio.substr(0, 2));

		let finMinutos = parseInt(fin.substr(3, 2));
		let finHoras = parseInt(fin.substr(0, 2));
		if (inicioHoras > finHoras) {
			finHoras = 24 + finHoras
		}
		let transcurridoMinutos = finMinutos - inicioMinutos;
		let transcurridoHoras = finHoras - inicioHoras;

		if (transcurridoMinutos < 0) {
			transcurridoHoras--;
			transcurridoMinutos = 60 + transcurridoMinutos;
		}

		let horas = transcurridoHoras.toString();
		//let minutos = transcurridoMinutos.toString();

		if (horas.length < 2) {
			horas = "0" + horas;
		}

		if (horas.length < 2) {
			horas = "0" + horas;
		}
		console.log("Horas restadas: " + horas + " - HoraIngreso: " + horaIngreso + " - HoraFinal: " + horaFin)
		if (transcurridoHoras >= horasLimites) {
			return true
		} else if (transcurridoHoras < horasLimites) {
			return false
		} else {
			return false
		}
	}

	restarDate(date1, limite) {
		try {
			var d2 = new Date().getTime()
			let resta = d2 - date1.toMillis()
			let result = Math.round(resta / (1000 * 60 * 60))
			if (result < limite) {
				return false;
			} else if (result > limite) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			console.log(error)
		}
	}

	registrarHora(id, accion, hora, usuario, limiteHora) {
		//console.log("registrarHora - " + id + "  - " + accion + "  -   " + hora)
		try {
			return new Promise((resolve, reject) => {
				let docarray = []
				this.BaseDeDatos.collection("Marcar").doc(id).collection("Log").orderBy("Date", "desc")
					.limit(1)
					.get().then((querySnapshot: any) => {
						querySnapshot.forEach(function (doc) {
							docarray.push({
								id: doc.id,
								datos: doc.data(),
							})
						});
						if (docarray.length == 0) {
							if (accion == "Ingreso") {
								this.MarcarIngreso(id, hora, usuario).then((res: any) => {
									resolve(res)
								});
							} else if (accion == "Salida") {
								resolve("ErrorSalida")
							}
						} else if (docarray.length != 0) {
							//	let diadehoy = this.obtenerFechayHora();
							if (accion == "Ingreso") {
								if (docarray[0].datos.Salida == "") {
									let permiso = this.restarDate(docarray[0].datos.Date, limiteHora)
									if (permiso == true) {
										this.MarcarSalida(id, docarray[0].id, hora).then((res: any) => {
											this.MarcarIngreso(id, hora, usuario).then((res: any) => {
												resolve(res)
											});
										})
									} else {
										resolve("YaMarco")
									}
								} else {
									this.MarcarIngreso(id, hora, usuario).then((res: any) => {
										resolve(res)
									});
								}
							} else if (accion == "Salida") {
								this.MarcarSalida(id, docarray[0].id, hora).then((res: any) => {
									resolve(res)
								})
							}
						}
					}).catch(error => {
						console.log(error)
					})
			})
		} catch (error) {
			console.log(error)
		}
	}

}

